const state = () => ({
  deleted: false
});

const getters = {
  deleted(state) {
    return state.deleted;
  }
};

const mutations = {
  setDeleted(state, payload) {
    state.deleted = payload;
  },
  resetStore(currentState) {
    Object.assign(currentState, state());
  }
};

export const accountDelete = {
  state,
  getters,
  mutations,
  namespaced: true
};
